var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import formatNumber from '@cores/utils/formatNumber';
import { DetailServiceSymbol } from '@/services/DetailService';
import { inject, injectService, injectable } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { FolderSettingService } from '@/domains/detail/folder/types/folder-setting-service.interface';
import { TaggingSettingService } from '@/domains/ai-tagging/services/tagging-setting-service.interface';
import { AI_MODEL_LIMITS } from '@/domains/ai-tagging/constants';
export var StepperType;
(function (StepperType) {
    StepperType["SELECT_FIELD"] = "SELECT_FIELD";
    StepperType["ACT_RULE"] = "RULE";
    StepperType["ACT_AI"] = "AI";
    StepperType["RESULT"] = "RESULT"; // 结果
})(StepperType || (StepperType = {}));
export var ActType;
(function (ActType) {
    ActType["RULE"] = "RULE";
    ActType["AI"] = "AI";
})(ActType || (ActType = {}));
export var FieldType;
(function (FieldType) {
    FieldType["OPTION"] = "OPTION";
    FieldType["LAYER"] = "LAYER";
})(FieldType || (FieldType = {}));
const MAX_LIMIT_COUNT = 50000;
export const SmartAnnotationServiceSymbol = Symbol.for('SmartAnnotationService');
let SmartAnnotationService = class SmartAnnotationService {
    constructor(pageSelectorService, detailService, folderSettingService, taggingSettingService) {
        this.pageSelectorService = pageSelectorService;
        this.detailService = detailService;
        this.folderSettingService = folderSettingService;
        this.taggingSettingService = taggingSettingService;
        // visible = false;
        this.step = StepperType.SELECT_FIELD;
        this.actType = ActType.RULE;
        this.aiSelectedNodeKeys = null;
        this.aiNodeData = null;
        this.aiTaggingCapacityData = null;
        this.currentField = null;
        this.defaultSelectedFieldId = '';
        this.task = null;
    }
    get limit() {
        const currentAiModel = this.taggingSettingService.getSettingData().aiModel;
        const aiModelLimit = AI_MODEL_LIMITS[currentAiModel] || MAX_LIMIT_COUNT;
        return {
            [ActType.AI]: aiModelLimit,
            [ActType.RULE]: MAX_LIMIT_COUNT,
        };
    }
    get currentFieldId() {
        return this.currentField?.field_id;
    }
    // isAiViewMode = false; // AI标引下，可以暂时隐藏抽屉，此时界面上显示一个提示框，表示正在标注学习标引。
    init() {
        this.step = StepperType.SELECT_FIELD;
        this.currentField = null;
        // this.isAiViewMode = false;
        this.defaultSelectedFieldId = null;
        this.aiSelectedNodeKeys = null;
        this.task = null;
    }
    getSearchParam() {
        const { qid, efqid, refiner } = this.detailService;
        const { mode, finalIds, rangeFrom, rangeTo } = this.pageSelectorService;
        const sort = this.folderSettingService.folderSetting.current_sort;
        const params = {
            efqid,
            qid,
            select_mode: mode,
            patent_ids: finalIds,
            refiner,
            sort,
            start: rangeFrom,
            end: rangeTo,
        };
        if (this.pageSelectorService.selectedCount === 0) {
            params.select_mode = 'EXCLUDE';
            params.patent_ids = [];
        }
        return params;
    }
    start({ defaultSelectedFieldId, actType }) {
        this.init();
        this.defaultSelectedFieldId = defaultSelectedFieldId || '';
        this.actType = actType || ActType.RULE;
        // this.visible = true;
    }
    // exit(preserveStatus = false) {
    //     // this.visible = false;
    //     if (!preserveStatus) {
    //         this.init();
    //     }
    // }
    setStep(step, option) {
        this.step = step;
        if (option && option.task) {
            this.task = option.task;
        }
    }
    get selectedPatentCount() {
        return this.pageSelectorService.selectedCount || this.pageSelectorService.totalCount;
    }
    get selectedPatentCountText() {
        const i18n = injectService(i18nSymbol);
        if (!this.pageSelectorService.selectedCount || this.pageSelectorService.selectedCount === this.pageSelectorService.totalCount) {
            return i18n.t('SmartAnnotation.SELECT_FIELD.currentPatentCount', { num: formatNumber(this.pageSelectorService.totalCount) });
        }
        return i18n.t('SmartAnnotation.SELECT_FIELD.selectPatentCount', { num: formatNumber(this.pageSelectorService.selectedCount) });
    }
    isOverLimit(type) {
        const i18n = injectService(i18nSymbol);
        if (this.selectedPatentCount > this.limit[type]) {
            return {
                message: i18n.t('SmartAnnotation.SELECT_FIELD.isOverLimit', { num: formatNumber(this.limit[type]) }),
            };
        }
        return false;
    }
    setAiSelectedNodeKeys(aiSelectedNodeKeys) {
        this.aiSelectedNodeKeys = aiSelectedNodeKeys;
    }
    setAiNodeData(aiNodeData) {
        this.aiNodeData = aiNodeData;
    }
};
SmartAnnotationService = __decorate([
    injectable(),
    __param(0, inject(PageSelectorServiceSymbol)),
    __param(1, inject(DetailServiceSymbol)),
    __param(2, inject(FolderSettingService)),
    __param(3, inject(TaggingSettingService)),
    __metadata("design:paramtypes", [Object, Object, typeof (_a = typeof FolderSettingService !== "undefined" && FolderSettingService) === "function" ? _a : Object, typeof (_b = typeof TaggingSettingService !== "undefined" && TaggingSettingService) === "function" ? _b : Object])
], SmartAnnotationService);
export { SmartAnnotationService };
